import React from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from 'react-redux';
import { NavHashLink as NavLink } from 'react-router-hash-link';

import { isMocked } from '../actions/authentication';
import sensotrendLogo from '../images/sensotrend.svg';

function Header() {
  const reduxStore = useSelector(state => state, shallowEqual);
  const { t } = useTranslation('account');

  const { session } = reduxStore;
  const { user } = session;

  return (
    <header id="auth">
      {(user && user.name && !isMocked(user))
        ? (
          <NavLink
            role="menuitem"
            className="primary button"
            to="/agp">
            {t('header.myReports')}
          </NavLink>
        )
        : (
          <NavLink
            role="menuitem"
            className="primary button"
            to="/signin">
            {t('header.logIn')}
          </NavLink>
        )}
      <img id="headerLogo" src={sensotrendLogo} alt="Sensotrend" />
    </header>
  );
}

export default Header;
